import { formatDateObjectToString } from 'syf-js-utilities/formats';
const generatePaymentMutationPayload = (paymentScheduledDate, paymentAmount, paymentMethod) => {
    var _a;
    const paymentMedium = (_a = paymentMethod.paymentMedium) !== null && _a !== void 0 ? _a : 'E_CHECK';
    const payload = {
        date: formatDateObjectToString(paymentScheduledDate),
        amount: Number(paymentAmount).toFixed(2)
    };
    if (paymentMedium === 'E_CHECK') {
        return Object.assign(Object.assign({}, payload), { paymentMedium: 'E_CHECK', paymentMethod: {
                id: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id
            } });
    }
    if (paymentMedium === 'CREDIT_CARD') {
        return Object.assign(Object.assign({}, payload), { paymentMedium: 'CREDIT_CARD', paymentCardInfo: {
                id: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id
            } });
    }
    if (paymentMedium === 'PINLESS_DEBIT_CARD') {
        return Object.assign(Object.assign({}, payload), { paymentMedium: 'PINLESS_DEBIT_CARD', paymentCardInfo: {
                id: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id
            } });
    }
    throw new Error('Invalid payment medium');
};
export default generatePaymentMutationPayload;
